var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',{class:[{'pt-3': _vm.$vuetify.breakpoint.smAndDown},
                           {'pt-2': _vm.$vuetify.breakpoint.mdAndUp}, 'px-3']},[_vm._v(" Doppelstart-Kontrolle ")]),_c('v-card-subtitle',{staticClass:"px-3 pb-2"},[_vm._v(" "+_vm._s(_vm.landesverbandLocal.name)+" "+_vm._s(_vm.sportJahr.replace('_', '/'))+" ")]),_c('doppel-start-tab',{attrs:{"doppelstart-docs":_vm.doppelstarts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }